const languages = [
	{
		key: "de",
		value: "DE",
	},
	{
		key: "en",
		value: "EN",
	},
];

export { languages };
